import { useEffect, useState } from "react";
import emailjs from "emailjs-com";
import { motion, AnimatePresence } from "framer-motion";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";

const COMPANY_EMAIL = "info@hline.in";
const COMPANY_PHONE = "+91 90817 24247";
const COMPANY_ADDR =
  "Plot No-80/A, Nr. Nayra Petrol Pump, Simada To Canal Road, Surat. 395006";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [currentImage, setCurrentImage] = useState(0);
  const AZURE_BASE_URL =
    "https://hlineweb-f6dwh8btedejg7fz.z03.azurefd.net//hlinefiles/HLineWeb/Projects/assets/projects/windows/";

  const images = [
    `${AZURE_BASE_URL}CHL00625-HDR.jpg`,
    `${AZURE_BASE_URL}CHL00701-HDR.jpg`,
    `${AZURE_BASE_URL}CHL00908-HDR.jpg`,
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .send("service_r1wa0nr", "template_u1slt2k", form, "tYD5Kty3T0MoBox3i")
      .then(
        () => {
          setStatus("success");
          setForm({ name: "", phone: "", email: "", message: "" });
          setTimeout(() => setStatus(""), 3000);
        },
        () => {
          setStatus("error");
          setTimeout(() => setStatus(""), 3000);
        }
      );
  };

  return (
    <div className="bg-transparent text-white animate-[page-in_.35s_ease]">
      <section className="relative w-full h-[60vh] overflow-hidden flex items-center justify-start">
        <AnimatePresence mode="wait">
          <motion.img
            key={currentImage}
            src={images[currentImage]}
            alt="Contact Hero"
            className="absolute inset-0 w-full h-full object-cover"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.6 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          />
        </AnimatePresence>

        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/40 to-transparent" />

        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="relative z-10 container"
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold max-w-3xl">
            Get In Touch
          </h1>
          <p className="mt-4 text-white/80 text-base sm:text-lg max-w-xl leading-relaxed">
            Have a project in mind? Let’s collaborate and bring your ideas to
            life with precision engineering and expert craftsmanship.
          </p>
        </motion.div>
      </section>

      <section id="contact" className="py-14 md:py-20 border-t border-white/10">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-stretch">
            <form
              onSubmit={handleSubmit}
              className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 md:p-10 flex flex-col justify-between"
            >
              <div className="space-y-6">
                <input
                  type="text"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Your name"
                  className="w-full rounded-md bg-white/[0.06] border border-white/10 px-4 py-3 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/20"
                  required
                />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    type="text"
                    value={form.phone}
                    onChange={(e) =>
                      setForm({ ...form, phone: e.target.value })
                    }
                    placeholder="Phone"
                    className="w-full rounded-md bg-white/[0.06] border border-white/10 px-4 py-3 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/20"
                  />
                  <input
                    type="email"
                    value={form.email}
                    onChange={(e) =>
                      setForm({ ...form, email: e.target.value })
                    }
                    placeholder="Email"
                    className="w-full rounded-md bg-white/[0.06] border border-white/10 px-4 py-3 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/20"
                    required
                  />
                </div>
                <textarea
                  rows={8}
                  value={form.message}
                  onChange={(e) =>
                    setForm({ ...form, message: e.target.value })
                  }
                  placeholder="Message"
                  className="w-full rounded-md bg-white/[0.06] border border-white/10 px-4 py-3 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/20"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={status === "sending"}
                className="px-8 py-3 bg-white text-black font-semibold rounded-md hover:bg-white/90 transition disabled:opacity-70 disabled:cursor-not-allowed w-full mt-6"
              >
                {status === "sending" ? "Sending..." : "Send"}
              </button>

              {status === "success" && (
                <p className="text-green-400 text-center text-sm mt-2">
                  ✅ Message sent successfully!
                </p>
              )}
              {status === "error" && (
                <p className="text-red-400 text-center text-sm mt-2">
                  ❌ Failed to send. Try again later.
                </p>
              )}
            </form>

            <div className="flex flex-col justify-between bg-white/5 backdrop-blur-sm border border-white/10 overflow-hidden">
              <div className="h-[400px] md:h-[500px]">
                <iframe
                  title="H-Line Windows & Façade Office Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.3295443972487!2d72.90675057593564!3d21.18131808472052!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04d23cb1ad1cf%3A0xc6f34c79dbe1ad05!2sH-LINE%20WINDOWS%20%26%20FA%C3%87ADE!5e0!3m2!1sen!2sin!4v1717167261234!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  allowFullScreen=""
                  loading="lazy"
                  className="w-full h-full border-0"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              <div className="p-6 space-y-4 border-t border-white/10">
                <div className="flex items-start gap-3">
                  <FiMapPin className="mt-1 text-white/70 shrink-0" size={18} />
                  <p className="text-white/80">{COMPANY_ADDR}</p>
                </div>
                <div className="flex items-center gap-3">
                  <FiPhone className="text-white/70" size={18} />
                  <a
                    href={`tel:${COMPANY_PHONE}`}
                    className="text-white/80 hover:text-white"
                  >
                    {COMPANY_PHONE}
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <FiMail className="text-white/70" size={18} />
                  <a
                    href={`mailto:${COMPANY_EMAIL}`}
                    className="text-white/80 hover:text-white"
                  >
                    {COMPANY_EMAIL}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
